import Vue from 'vue'
import router from '@/router'

import {axiosInstance} from "@/api/modules/si-api-instance";
import store from '@/store';


const apiLogin = (username, password) => {
    return axiosInstance.post('login', {
        username: username,
        password: password
    })
    .then(function (response) {
        if(response.data.status){
          store.dispatch('auth/setUser', {
            token:response.data.token,
            nombre:response.data.nombre,
            profile_pic:response.data.profile_pic,
            organization_id:response.data.organization_id,
            rol_id:response.data.rol_id,
            rol:response.data.rol,
            organization:response.data.organization
          })
          Vue.$cookies.set('token', response.data.token);
          Vue.$cookies.set('name', response.data.nombre);
          Vue.$cookies.set('profile_pic', response.data.profile_pic);
          Vue.$cookies.set('organization_id', response.data.organization_id);
          Vue.$cookies.set('rol_id', response.data.rol_id);
          Vue.$cookies.set('rol', response.data.rol);
          Vue.$cookies.set('organization', response.data.organization);
          router.push('/');

        }
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const apiVerifyToken = (token) => {
  return axiosInstance.get(process.env.VUE_APP_API+'verifyToken', {
      params:{
          token: token
      }
  })
  .then(function (response) {
      return response;
  })
  .catch(function (error) {
      return error;
  });
}

const logout = ()=>{
  delete axiosInstance.defaults.headers.common['Authorization'];
}
export default {
    apiLogin,
    apiVerifyToken,
    logout
};
